export default {
  id: "restaurant",
  brandIcon: "🍽️",
  defaultModule: "acceuil",
  footerNote: "Restaurant ERP · Hospitality Suite",
};
